export const selectPlayerFitType = (store)=>store.playerSettings.objectFit
